import React, { createContext, useContext, useState } from 'react';

const FeatureFlagsContext = createContext();

export const useFeatureFlags = () => {
  const context = useContext(FeatureFlagsContext);
  if (!context) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagsProvider');
  }
  return context;
};

export const FeatureFlagsProvider = ({ children }) => {
  // All feature flags are enabled by default
  const [featureFlags, setFeatureFlags] = useState({
    // Site sections
    heroSection: true,
    roleBasedEntryPoints: true,
    metricsBar: true,
    servicesPreview: true,
    caseStudyCarousel: true,
    ctaSection: true,
    
    // Products page sections
    productsHero: true,
    serverManagement: true,
    customIntegrations: true,
    noCodePlatform: true,
    earlyAccess: true,
    
    // Navigation
    productsNavigation: true,
    languageSwitcher: true,
    
    // Global features
    animatedLogo: true,
    multiLanguage: true
  });

  const toggleFeatureFlag = (flag) => {
    setFeatureFlags(prev => ({
      ...prev,
      [flag]: !prev[flag]
    }));
  };

  const isFeatureEnabled = (flag) => {
    return featureFlags[flag] || false;
  };

  const value = {
    featureFlags,
    toggleFeatureFlag,
    isFeatureEnabled
  };

  return (
    <FeatureFlagsContext.Provider value={value}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};